// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3JPz5","title":"ClientInsurance_title__3qw7t","itemText":"ClientInsurance_itemText__Lp2MA"};